<template>
  <div class="classDetailStudent">
    <el-card>
      <div>
        <el-row :gutter="20">
          <el-col :sm="6" :md="5" :lg="5">
            <el-input v-model="classInfoOrderInfoSearch.name" placeholder="姓名/电话"></el-input>
          </el-col>
          <el-col :sm="6" :md="4" :lg="4">
            <el-button type="primary" icon="el-icon-search" @click="classInfoOrderInfoPageList()">查询</el-button>
          </el-col>
          <el-col :sm="12" :md="15" :lg="15" style="text-align:right">
            <el-button type="primary" @click="studentAllPageList()">添加学员</el-button>
            <el-button @click="copyStudentShow = true, openCopyStudent()">复制学员</el-button>
            <!-- <el-button @click="exportExcel()">导出学员</el-button> -->
          </el-col>
        </el-row>
      </div>
      <el-table ref="multipleTable" :data="studentList.records" style="width: 100%;margin-top:20px;" border @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="student.name" show-overflow-tooltip label="学员姓名"></el-table-column>
        <el-table-column prop="student.mobile" label="手机号" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="所属校区" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input maxlength="100" ref="inputIndex" autofocus="true" @blur="confirmEdit(scope.row)" v-model="scope.row.campusName" type="text" placeholder="请输入所属校区" size="mini"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="courseName" label="报名科目" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="goodsName" label="商品" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="creatorName" label="添加人" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="shareUserName" label="推荐人" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createTime" label="添加日期" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="answer" label="操作" align="center" show-overflow-tooltip width="120">
          <template slot-scope="scope">
            <el-button type="text" @click="copyStudentShow = false, changeClass(scope.row)">转移</el-button>
            <el-button type="text" @click="removeStudent(scope.row)">移除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-pagination
                background
                layout="prev, pager, next, jumper,  total, sizes"
                style="margin-top: 20px;text-align: left;"
                :total="studentList.total"
                :page-size="studentList.pageSize"
                :page-sizes="[10, 20, 30, 40]"
                :current-page="studentList.pageNumber"
                @size-change="studentListSizeChange"
                @current-change="studentListCurrentChange"
      ></el-pagination>-->

      <el-dialog title="添加学员" :visible.sync="studentDialogVisible" :close-on-click-modal="false" width="60%">
        <el-form :model="studentAllSearch" label-width="0px">
          <el-row :gutter="20">
            <el-col :sm="24" :md="6" :lg="6">
              <el-cascader style="width:100%" clearable v-model="studentAllSearch.campusIds" :show-all-levels="false" :props="campusTreeProp" placeholder="请选择所属校区" :options="campusList"></el-cascader>
            </el-col>
            <el-col :sm="24" :md="6" :lg="6">
              <el-cascader style="width:100%" clearable v-model="studentAllSearch.courseIds" :show-all-levels="false" :props="subjectTreeProps" placeholder="请选择所属科目" :options="subjectCourseTreeList"></el-cascader>
            </el-col>
            <el-col :sm="24" :md="6" :lg="6">
              <el-input clearable v-model="studentAllSearch.name" placeholder="学员姓名/手机号" auto-complete="off" maxlength="100"></el-input>
            </el-col>
            <el-col :sm="24" :md="6" :lg="6">
              <el-date-picker style="width:100%" v-model="studentAllSearch.period" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            </el-col>
          </el-row>
          <el-row style="margin-top:10px;" :gutter="20">
            <el-col :sm="24" :md="6" :lg="6" style="float:right">
              <el-button type="primary" class="classRoomButton" style="float:right" @click="addClassInfoOrderInfo()">添加</el-button>
              <el-button type="primary" class="classRoomButton" style="float:left" @click="studentAllPageList()">查询</el-button>
            </el-col>
          </el-row>
        </el-form>
        <el-table ref="multipleTable" :data="studentAllList.records" style="width: 100%;margin-top: 10px;" row-key="id" border @selection-change="studentAllSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="id" label="状态" width="100" show-overflow-tooltip>
            <template slot-scope="row">
              <span class="courseManage style1" v-if="row.row.scheduleStateName == '已排课'" @click="goAddClass(row.row)">{{ row.row.scheduleStateName }}</span>
              <span class="courseManage style1" v-if="row.row.scheduleStateName == '开课中'" @click="goAddClass(row.row)">{{ row.row.scheduleStateName }}</span>
              <span class="courseManage style2" v-if="row.row.scheduleStateName == '未排课'" @click="goAddClass(row.row)">{{ row.row.scheduleStateName }}</span>
              <span class="courseManage style3" v-if="row.row.scheduleStateName == '已结束'" @click="goAddClass(row.row)">{{ row.row.scheduleStateName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="campusName" label="报名校区" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="studentName" label="学员姓名" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="mobile" label="学员电话" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="createTime" label="报名时间" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="courseName" show-overflow-tooltip label="报名课程"></el-table-column>
        </el-table>
        <el-pagination background layout="prev, pager, next, jumper,  total, sizes" style="margin-top: 20px;text-align: left;" :total="studentAllList.total" :page-size="studentAllList.pageSize" :page-sizes="[10, 20, 30, 40]" :current-page="studentAllList.pageNumber" @size-change="studentAllSizeChange" @current-change="studentAllCurrentChange"></el-pagination>
      </el-dialog>

      <el-dialog class="addDialog" :title="changeClassDialogTitle" width="400px" :visible.sync="changeClassDialog">
        <el-form :model="changeClassForm" status-icon ref="changeClassForm" label-width="80px" class="demo-ruleForm" :rules="changeClassFormRules">
          <!-- <el-form-item label="所属校区" prop="campusId">
            <el-cascader
              style="width:100%"
              clearable
              v-model="changeClassForm.campusId"
              :show-all-levels="false"
              :props="campusListProps"
              placeholder="请选择所属校区"
              :options="campusList"
              @change="changeGetClassInfo(changeClassForm.campusId)"
            ></el-cascader>
          </el-form-item>-->
          <el-form-item label="所属科目" prop="courseId">
            <el-cascader style="width:100%" class="research-select" clearable v-model="changeClassForm.courseId" :show-all-levels="false" :props="subjectTreeProps" placeholder="请输入所属科目" :options="subjectTreeList" @change="subjectSearchChange(changeClassForm.courseId[1])"></el-cascader>
          </el-form-item>
          <el-form-item label="所属班级" prop="classInfoPhaseId">
            <el-select placeholder="请选择班级期数" style="width:100%" v-model="changeClassForm.classInfoPhaseId" @change="classInfoChange(changeClassForm.classInfoPhaseId)" clearable>
              <el-option v-for="item in classInfoPhaseList" :key="item.id" :label="'第' + item.phase + '期'" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属课程" prop="classInfoId">
            <el-select placeholder="请选择班级期数" style="width:100%" v-model="changeClassForm.classInfoId" clearable>
              <el-option v-for="item in classInfoList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="text-align:right">
            <el-button @click="changeClassDialog = false">取消</el-button>
            <el-button type="primary" @click="transferClassInfoSelect">提交</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  data () {
    return {
      changeClassDialogTitle: '转班',
      copyStudentShow: false,
      studentDialogVisible: false,
      studentCopyDialogVisible: false,
      changeClassDialog: false,
      changeCourseDialog: false,
      studentList: {},
      classInfoOrderInfoSearch: {
        pageNumber: 1,
        pageSize: 1000,
        classInfoId: null
      },
      multipleSelection: [],
      ids: [],
      studentSearch: {},
      studentAllSearch: {
        pageNumber: 1,
        pageSize: 10,
        campusIds: [],
        courseIds: [],
        courseId: "",
        period: []
      },
      campusList: [],
      classroomList: [],
      subjectTreeList: [],
      subjectCourseTreeList: [],
      classInfoList: [],
      classInfoPhaseList: [],
      studentAllList: {},
      changeClassForm: {
        courseId: null,
        classInfoPhaseId: null,
        classInfoId: null,
        idList: []
      },
      copyClassForm: {},
      changeCourseForm: {},
      studentAllSelection: {
        idList: [],
        classInfoId: ""
      },
      campusTreeProps: {
        value: "id",
        label: "name",
        children: "children",
        checkStrictly: true
      },
      campusTreeProp: {
        value: "id",
        label: "name",
        children: "children"
      },
      campusListProps: {
        value: "id",
        label: "name",
        children: "children"
      },
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children"
      },
      changeClassFormRules: {
        campusId: [
          {
            required: true,
            message: "请选择所属校区",
            trigger: "change"
          }
        ],
        courseId: [
          {
            required: true,
            message: "请选择所属科目",
            trigger: "change"
          }
        ],
        classInfoPhaseId: [
          {
            required: true,
            message: "请选择所属班级",
            trigger: "change"
          }
        ],
        classInfoId: [
          {
            required: true,
            message: "请选择所属课程",
            trigger: "change"
          }
        ]
      }
    };
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData () {
      return this.$store.state.user;
    }
  },
  methods: {
    confirmEdit (row) {
      console.log(row)
      if (row.campusName != "" && row.campusName != null) {
        this.api.classroom.updateClassInfoStudent({
          id: row.id,
          campusName: row.campusName,
        }).then((res) => {
          if (res.success) {
            this.$message.success("操作成功");
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    getCampusList () {
      this.api.campus
        .getCampusTree({ parentId: 1 })
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    if (itemss.children.length != 0) {
                      delete itemss.children;
                    } else {
                      delete itemss.children;
                    }
                  }
                } else {
                  delete items.children;
                }
              }
            } else {
              delete item.children;
            }
          }
          this.campusList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 获取课程
    getSubjectCourseTreeList () {
      this.api
        .getSubjectCourseTreeList()
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    delete itemss.children;
                  }
                } else {
                  // delete items.children;
                }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectCourseTreeList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 获取科目
    getSubjectTreeList () {
      this.api
        .getSubjectCourseTreeList()
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                delete items.children;
                // if (items.children.length != 0) {
                //   for (let itemss of items.children) {
                //     delete itemss.children;
                //   }
                // } else {
                //   // delete items.children;
                // }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    getClassInfoPhaseList () {
      this.api.classInfoPhase.getClassInfoPhaseList().then(result => {
        if (result.success) {
          this.classInfoPhaseList = result.data;
          this.changeClassDialog = true;
        } else {
          this.$message.error(result.message);
        }
      });
    },
    classInfoOrderInfoPageList () {
      // if (this.classInfoOrderInfoSearch.courseIds.length > 0) {
      //   this.classInfoOrderInfoSearch.courseId = this.classInfoOrderInfoSearch.courseIds[2];
      // } else {
      //   this.classInfoOrderInfoSearch.courseId = "";
      // }
      this.classInfoOrderInfoSearch.classInfoId = this.$route.query.id;
      this.api.classInfoStudent
        .pageList(this.classInfoOrderInfoSearch)
        .then(result => {
          if (result.data != null) {
            this.studentList = result.data;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    studentAllPageList () {
      if (typeof this.studentAllSearch.courseIds == "object") {
        let index = this.studentAllSearch.courseIds.length;
        this.studentAllSearch.courseId = this.studentAllSearch.courseIds[
          index - 1
        ];
      }
      if (typeof this.studentAllSearch.campusIds == "object") {
        let index = this.studentAllSearch.campusIds.length;
        this.studentAllSearch.campusId = this.studentAllSearch.campusIds[
          index - 1
        ];
      }
      if (this.studentAllSearch.period) {
        if (this.studentAllSearch.period.length > 0) {
          this.studentAllSearch.beginDate = this.studentAllSearch.period[0];
          this.studentAllSearch.endDate = this.studentAllSearch.period[1];
        }
      }
      // this.api.studentCourse
      //   .studentPageList(this.studentAllSearch)
      this.api.student
        .classInfoList(this.studentAllSearch)
        .then(result => {
          this.studentAllList = result.data;
          this.studentDialogVisible = true;
        })
        .catch(error => {
          console.log(error);
        });
    },
    addClassInfoOrderInfo () {
      if (this.studentAllSelection.idList.length == 0) {
        this.$message.error("请选择需要添加的学员");
      } else {
        this.api.classInfoStudent
          .addClassInfoStudent(this.studentAllSelection)
          .then(result => {
            this.$message({
              type: "success",
              message: result.message
            });
            this.activeName = "third";
            this.studentDialogVisible = false;
            this.classInfoOrderInfoPageList();
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    changeGetClassInfo (id) {
      this.$set(this.changeClassForm, "classInfoId", "");
      let index = 0;
      if (id.length > 0) {
        index = id.length;
      }
      this.api.classInfo
        .getClassInfoList({ campusId: id[index - 1] })
        .then(result => {
          if (result.success) {
            this.classInfoList = result.data;
            if (this.classInfoList.length == 0) {
              this.$message.error("该校区暂无班级");
            }
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    subjectSearchChange (id) {
      // this.searchForm.subjectCourseId = this.addForm.subjectCourseId[1];
      this.api.classInfoPhase
        .getClassInfoPhaseList({
          subjectCourseId: id
        })
        .then(result => {
          if (result.success) {
            this.classInfoPhaseList = result.data;
            this.changeClassForm.classInfoPhaseId = null;
          } else {
            this.$message.error(result.message);
          }
        });
    },
    classInfoChange (id) {
      this.api.classInfo
        .getClassInfoList({ classInfoPhaseId: id })
        .then(result => {
          if (result.success) {
            this.classInfoList = result.data;
            this.changeClassForm.classInfoId = null;
          } else {
            this.$message.error(result.message);
          }
        });
    },
    studentAllSelectionChange (val) {
      // this.studentAllSelection.agentId = JSON.parse(
      //   localStorage.getItem("user")
      // ).agentId;
      // this.studentAllSelection.classInfoId = this.jump.id;
      this.studentAllSelection.idList = [];
      this.studentAllSelection.classInfoId = this.$route.query.id;
      for (let item of val) {
        this.studentAllSelection.idList.push(item.id);
      }
    },
    studentAllSizeChange (pageSize) {
      this.studentAllSearch.pageSize = pageSize;
      this.studentAllPageList();
    },
    studentAllCurrentChange (pageNumber) {
      this.studentAllSearch.pageNumber = pageNumber;
      this.studentAllPageList();
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
      // this.ids = val.map(res=>{
      //   return {id: res.id}
      // })
      this.changeClassForm.idList = [];
      val.forEach(res => {
        this.changeClassForm.idList.push(res.student.id);
      });
    },
    openCopyStudent () {
      if (this.multipleSelection.length > 0) {
        this.getSubjectTreeList();
        this.changeClassDialog = true;
        this.changeClassDialogTitle = "复制学员";
      } else {
        this.copyStudentShow = false;
        this.$message.warning("请选择需要复制的学员！");
      }
    },
    changeClass (row) {
      this.changeClassDialogTitle = '转班';
      // this.$set(this.changeClassForm, "campusId", row.campusId);
      this.getSubjectTreeList();
      // this.getCampusList();
      // this.getClassInfoList(row.campusId);
      // this.$set(this.changeClassForm, "courseId", row.courseId);
      // this.$set(this.changeClassForm, "classInfoId", row.classInfoId);
      this.changeClassForm.idList = [];
      // this.changeClassForm.idList.push(row.id);
      this.$set(this.changeClassForm, "id", row.id);
      this.changeClassDialog = true;
    },

    transferClassInfoSelect () {
      if (this.copyStudentShow) {
        this.copyStudent();
      } else {
        this.transferClassInfo();
      }
    },
    transferClassInfo () {
      this.$refs.changeClassForm.validate(valid => {
        if (valid) {
          if (typeof this.changeClassForm == "object") {
            this.changeClassForm.courseId = this.changeClassForm.courseId[1];
          }
          this.api.classInfoStudent
            .transferClass(this.changeClassForm)
            .then(result => {
              this.changeClassDialog = false;
              this.classInfoOrderInfoPageList();
            })
            .catch(error => {
              console.log(error);
            });
        }
      });
    },
    copyStudent () {
      this.$refs.changeClassForm.validate(valid => {
        if (valid) {
          // console.log("changeClassForm",this.changeClassForm)
          if (typeof this.changeClassForm == "object") {
            this.changeClassForm.courseId = this.changeClassForm.courseId[1];
          }
          this.api.classInfoStudent
            .copyStudent(this.changeClassForm)
            .then(result => {
              if (result.success) {
                this.changeClassDialog = false;
                this.classInfoOrderInfoPageList();
                this.$message.success(result.message)
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        }
      });
    },
    removeStudent (row) {
      this.$confirm("将会移除此学员，是否确认移除？", "系统消息", {
        type: "warning"
      }).then(() => {
        let obj = { id: row.id };
        this.api.classInfoStudent
          .removeClassInfoStudent([obj])
          .then(result => {
            this.classInfoOrderInfoPageList();
          })
          .catch(error => {
            console.log(error);
          });
      });
    }
  },
  mounted () {
    this.classInfoOrderInfoPageList();
  },
  watch: {
    changeClassDialog (val) {
      if (!val) {
        this.$refs.changeClassForm.resetFields();
      }
    },
    studentDialogVisible (val) {
      if (val) {
        this.getCampusList();
        this.getSubjectCourseTreeList();
      }
    },

  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/classManage/student.vue